import {
  Sparkles, CircleDot, Sprout, Egg, Baby, HeartHandshake, Waves, Sun, Leaf,
  Stethoscope, Droplet, Flower2, ShieldPlus, Activity, HeartPulse, Salad,
  Bone, Pill, Microscope, Syringe, FileText, Scale, Dna, Brain, ScanLine,
  ClipboardList, Ribbon, Users, CalendarClock, CreditCard, Globe, Languages,
  ClipboardCheck, MessageSquareHeart, BookOpen, Compass, Route, Handshake,
} from "lucide-react";

// Keyword-based fine-line illustration mapping (calm editorial feel, strokeWidth 1).
const RULES = [
  ["adolescence", Sparkles],
  ["cycle-health", CircleDot],
  ["family-planning", Sprout],
  ["preconception", Sprout],
  ["fertility", Egg],
  ["ivf", Egg],
  ["pregnancy", Baby],
  ["prenatal", Baby],
  ["postpartum", HeartHandshake],
  ["perimenopause", Waves],
  ["menopause", Sun],
  ["ovarian-insufficiency", Sun],
  ["healthy-aging", Leaf],
  ["longevity", Leaf],
  ["general-gynecology", Stethoscope],
  ["menstrual-bleeding", Droplet],
  ["pelvic-pain", Flower2],
  ["endometriosis", Flower2],
  ["vulvar", ShieldPlus],
  ["urinary", ShieldPlus],
  ["contraception", CalendarClock],
  ["hormonal-health", Activity],
  ["amenorrhea", CircleDot],
  ["pmos", Dna],
  ["pms", Waves],
  ["recurrent-pregnancy-loss", Ribbon],
  ["clinical-nutrition", Salad],
  ["weight", Scale],
  ["cardiometabolic", HeartPulse],
  ["bone", Bone],
  ["muscle", Bone],
  ["orthomolecular", Pill],
  ["micronutrient", Pill],
  ["integrative", Leaf],
  ["complementary", Leaf],
  ["diagnostics", ScanLine],
  ["ultrasound", ScanLine],
  ["infusion", Syringe],
  ["second-opinion", FileText],
  ["record-review", FileText],
  ["fibroids", Microscope],
  ["polyps", Microscope],
  ["ovarian-cysts", Microscope],
  ["adnexal", Microscope],
  ["cervical", ShieldPlus],
  ["hpv", ShieldPlus],
  ["thyroid", Brain],
  ["prolactin", Brain],
  // approach
  ["why-patients", Sparkles],
  ["connected-care-model", Route],
  ["connected-plan", Compass],
  ["evidence", BookOpen],
  ["patient-experiences", MessageSquareHeart],
  ["professional-referrals", Handshake],
  // patient service
  ["prepare", ClipboardCheck],
  ["during", Stethoscope],
  ["after", ClipboardList],
  ["online-consultations", Globe],
  ["payments", CreditCard],
  ["international-patients", Globe],
  ["languages", Languages],
  // new 2026 category structure — German-language slugs
  ["zyklusbeschwerden", Droplet],
  ["pms-pmds", Waves],
  ["pmos", Dna],
  ["endometriose", Flower2],
  ["adenomyose", Flower2],
  ["schilddruesengesundheit", Brain],
  ["hormonanalysen", Activity],
  ["akne-haarausfall", Sparkles],
  ["libido", HeartPulse],
  ["erschoepfung", Sun],
  ["gewicht", Scale],
  ["insulinresistenz", Activity],
  ["praekonzeptionsberatung", Sprout],
  ["natuerlicher-kinderwunsch", Egg],
  ["ivf-icsi", Egg],
  ["fertilitaetsdiagnostik", ScanLine],
  ["wiederholte-fehlgeburten", Ribbon],
  ["schwangerschaft", Baby],
  ["naehrstoffoptimierung", Salad],
  ["stillzeit", HeartHandshake],
  ["regeneration-nach-geburt", HeartHandshake],
  ["bioidentische-hormontherapie", Pill],
  ["schlafstoerungen", Waves],
  ["hitzewallungen", Sun],
  ["osteoporoseprevention", Bone],
  ["herz-kreislauf-praevention", HeartPulse],
  ["praeventions-check-ups", Stethoscope],
  ["orthomolekular", Pill],
  ["mikro-makronaehrstoffmedizin", Pill],
  ["stoffwechselgesundheit", Activity],
  ["darmgesundheit", Leaf],
  ["chronische-entzuendungen", ShieldPlus],
  ["eisenmangel", Droplet],
  ["vitamin-mineralstoffdiagnostik", ScanLine],
  ["infusionstherapien", Syringe],
  ["lebensstilmedizin", Compass],
  ["ernaehrung", Salad],
  ["longevity-gesundheitsoptimierung", Leaf],
];

export function getIcon(slug = "") {
  for (const [key, Icon] of RULES) {
    if (slug.includes(key)) return Icon;
  }
  return Stethoscope;
}
